import LightBeaconIcon from "../images/LightBeaconIcon.mjs";

/**
 * App icon for CVE search operations
 * @see {GlyphIcon}
 * @see {LightBeaconIcon}
 */
const AppCpeCveExplorerIcon = class extends LightBeaconIcon {}

export default AppCpeCveExplorerIcon;